import React from 'react';

const InputFieldHttpAddon = () => {
  return (
    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <span className="text-gray-400">https://</span>
    </div>
  );
};

export default InputFieldHttpAddon;
